import script from "./MyPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./MyPagination.vue?vue&type=script&setup=true&lang=js"

import "./MyPagination.vue?vue&type=style&index=0&id=55f7a334&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55f7a334"]])

export default __exports__